import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Loading } from '../components';
import { getDate } from '../../format-date';
import './pollution-air.scss';
import { POLLUTION, COLORS_INDEX } from '../../consts/pollution';
import { LOCATION_JSON, URL_POLLUTION } from '../../consts/url-api';

export const PollutionAir = ({ lat, lon, city }) => {
    const coord_Kyiv = { lat: 50.4501, lon: 30.5241 };
    const [pollution, setPollution] = useState([]);
    const [coord, setCoord] = useState([]);
    const url = (!lat || !lon) ? URL_POLLUTION(coord[0], coord[1]) :
        !coord.length ? URL_POLLUTION(coord_Kyiv.lat, coord_Kyiv.lon) :
            URL_POLLUTION(lat, lon);

    useEffect(() => {
        axios.get(LOCATION_JSON)
            .then(res => setCoord([res.data.latitude, res.data.longitude]))
            .catch(error => console.log(error))
    }, []);

    useEffect(() => {
        axios.get(url)
            .then(res => setPollution(res.data))
            .catch(error => console.log(error))
        // eslint-disable-next-line
    }, [url]);

    return (
        <>
            {(!pollution.length && !Object.keys(pollution).length) ?
                <Loading /> :
                <div className='pollution'>
                    <div className='pollution_title'>
                        <h3 className='pollution_title-city'>
                            Стан забруднення повітря на {getDate(pollution.list[0].dt)}, {city}
                        </h3>
                        <h4 className='pollution_title-aqi'>
                            Становить {pollution.list[0].main.aqi}-й рівень, {POLLUTION[pollution.list[0].main.aqi - 1]}
                        </h4>
                    </div>
                    <TableContainer component={Paper} sx={{ maxWidth: 740, margin: '0 auto' }}>
                        <Table aria-label='simple table'>
                            <TableHead
                                sx={{
                                    backgroundColor: `${COLORS_INDEX[pollution.list[0].main.aqi - 1]}`,
                                    color: 'white'
                                }}>
                                <TableRow>
                                    <TableCell>Назва речовини</TableCell>
                                    <TableCell align='right'>Концентрація забрюднюючих речови в μg/m3</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell component='th' scope='row'> CO (Carbon monoxide)</TableCell>
                                    <TableCell align='right'>{pollution.list[0].components.co}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component='th' scope='row'>NO (Nitrogen monoxide)</TableCell>
                                    <TableCell align='right'>{pollution.list[0].components.no}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component='th' scope='row'>
                                        <span>NO<sub>2</sub> (Nitrogen dioxide)</span>
                                    </TableCell>
                                    <TableCell align='right'>{pollution.list[0].components.no2}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component='th' scope='row'>
                                        <span>O<sub>3</sub> (Ozone)</span>
                                    </TableCell>
                                    <TableCell align='right'>{pollution.list[0].components.o3}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component='th' scope='row'>
                                        <span>SO<sub>2</sub> (Sulphur dioxide)</span>
                                    </TableCell>
                                    <TableCell align='right'>{pollution.list[0].components.so2}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component='th' scope='row'>
                                        <span>PM<sub>2.5</sub> (Fine particles matter)</span>
                                    </TableCell>
                                    <TableCell align='right'>{pollution.list[0].components.pm2_5}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component='th' scope='row'>
                                        <span>PM<sub>10</sub> (Coarse particulate matter)</span>
                                    </TableCell>
                                    <TableCell align='right'>{pollution.list[0].components.pm10}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component='th' scope='row'>
                                        <span>NH<sub>3</sub> (Ammonia)</span>
                                    </TableCell>
                                    <TableCell align='right'>{pollution.list[0].components.nh3}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Outlet />
                </div>
            }
        </>
    )
}